import { DestinationReelPreviewSchema, type DestinationReelPreview } from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

/**
 * Resolve a YouTube Shorts / Instagram Reel link the way the public site will.
 * Shared by every editor that takes a reel URL - see DestinationReelPreviewSchema
 * for what each status means.
 */
export const previewReel = async (url: string): Promise<DestinationReelPreview> => {
  const { data } = await apiClient.get<unknown>('/admin/website/reels/preview', {
    params: { url },
  });
  return DestinationReelPreviewSchema.parse(data);
};
